import {
    SET_FILTERS,
    SET_CATEGORY,
    ORDER_LIST_APPLIED_FILTER_RESET,
    RESTORE_ORDER_FILTER_SNAPSHOT,
} from '../actions';

import { convertDateToISOString } from 'src/utils/util';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    filter: {
        district: '',
        territory: '',
        account: '',
        orderStatusCode: '',
        orderType: '',
        assignedFlag: true,
        startDate: '',
        // convertDateToISOString(
        //     new Date(
        //         addDaysToDate(new Date(new Date().setHours(0, 0, 0, 0)), -90)
        //     ),
        //     'start'
        // ),
        endDate: convertDateToISOString(new Date(new Date()), 'end'),
    },
    pageLimit: 50,
    isActionItem: true,
    pageNo: 0,
    sortOrder: 'DESC',
    sortParam: 'submitDate',
};

const AppliedFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FILTERS:
            return {
                ...state,
                filter: { ...action.payload.filter },
                pageNo:
                    action?.payload && action.payload?.pageNo !== undefined
                        ? action.payload.pageNo
                        : state.pageNo,
                sortOrder:
                    action?.payload && action.payload?.sortOrder !== undefined
                        ? action.payload.sortOrder
                        : state.sortOrder,
                sortParam:
                    action?.payload && action.payload?.sortParam !== undefined
                        ? action.payload.sortParam
                        : state.sortParam,
            };
        case SET_CATEGORY:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    orderType: action.payload,
                    orderStatusCode: '',
                },
            };
        case ORDER_LIST_APPLIED_FILTER_RESET:
            return {
                ...state,
                filter: {
                    ...initialState.filter,
                },
            };
        case RESTORE_ORDER_FILTER_SNAPSHOT:
            return {
                ...state,
                filter: action.payload.filter || { ...initialState.filter },
                pageNo: action.payload.pageNo !== undefined ? action.payload.pageNo : 0,
                sortOrder: action.payload.sortOrder !== undefined ? action.payload.sortOrder : 'DESC',
                sortParam: action.payload.sortParam !== undefined ? action.payload.sortParam : 'submitDate',
            };
        default:
            return {
                ...state,
            };
    }
};

export default persistReducer(
    {
        key: 'appliedOrderFilterKey',
        storage: storage,
        whitelist: ['filter'],
    },
    AppliedFilterReducer
);
